import React, {PropTypes} from 'react';

import SortableList from './SortableList';
import LabelGrid from './LabelGrid';

const LabelSheet = ({
  labels
}) => {
  return (
    <div className="label-sheet">
      <div className="row">
        <LabelGrid
          component={SortableList}
          distance={5}
          lockToContainerEdges={true}
          lockOffset={0}
          items={labels}
          helperClass="stylizedHelper"
          className="stylizedList grid"
          itemClass="stylizedItem gridSpace"
        />
      </div>
    </div>
  );
};

LabelSheet.propTypes = {
  labels: PropTypes.array.isRequired
};

export default LabelSheet;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/LabelSheet.js
 **/